<template>
  <form class="card-body" @submit.prevent="login()">
    <h2 class="card-login-title">Введите пароль</h2>


    <div v-if="password_sent" class="mb-2">
      Новый пароль установлен и отправлен на электронную почту
      <strong v-if="password_debug">{{ password_debug }}</strong>
    </div>
    <!-- <p v-if="!password_sent" class="card-login-title" style="margin: 10px 16px -17px;font-size: 1rem;text-align: left;">Если пароль не подходит, просим восстановить его воспользовавшись кнопкой, "Забыли пароль?"</p> -->

    <div class="form-group">
      <label for="input-login-password">Пароль</label>
      <input
        id="input-login-password"
        type="password"
        class="form-control form-control-lg"
        placeholder="Пароль"
        v-model="password"
        v-focus
        ref="input"
      >
    </div>

    <p class="text-danger" v-if="error"></p>

    <div class="form-actions">
      <button class="btn btn-primary btn-lg btn-block" type="submit">Продолжить</button>
      <button class="btn btn-link btn-block" @click="$emit('remindPassword')" type="button">Забыли пароль?</button>
      <button class="btn btn-link btn-block" @click="$emit('cancel')" type="button">Назад</button>
    </div>

    <div class="alert alert-danger" :class="{ 'new': error_new } " v-if="error">{{ error }}</div>
  </form>
</template>

<script>
  import { extend } from 'lodash'
  import auth from '../../auth'

  export default {
    props: [
      'auth',
      'password_sent',
      'password_debug',
    ],
    data () {
      return {
        password: '',
        error: '',
        error_new: false,
      }
    },
    computed: {
      authData () {
        return extend({password: this.password}, this.auth)
      },
    },
    methods: {
      login () {
        if (!this.password) {
          this.$refs.input.focus()
          return
        }

        auth.login(this.authData)
          .then((response) => {
            if (response == 'sms') {
              this.$emit('sms', this.authData)
            }
            else {
              this.$router.push('/')
            }
          })
          .catch((error) => {
            if (error.response) {
              this.error = error.response.data.email || 'Неверный пароль'
              // Highlight error
              this.error_new = true
              setTimeout(() => {
                this.error_new = false
              }, 100)
            } else {
              alert('Ошибка при выполнении запроса')
            }
          })
      },
    },
  }
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/assets/js/components/login/password.vue